import {
    NinchatActionType,
    NinchatSetTranscriptStatusAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {NinchatAckEvent} from 'api/types/events'

import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const setTranscriptStatus = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatSetTranscriptStatusAction}`,
    async (arg: NinchatActionParams<NinchatSetTranscriptStatusAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatSetTranscriptStatusAction

        try {
            return await ninchatClient.send(params) as NinchatAckEvent
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
